import { fulfillmentTransactionBeforeSave } from "services/sosInventoryService/fulfillmentTransaction/beforeSave";
import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/shipment/schema";
import { normalizeDateFields } from "services/utility/beforeSave";

import { OBJECT_TYPES } from "appConstants";

export function beforeSave(record) {
  const newRecord = fulfillmentTransactionBeforeSave(
    OBJECT_TYPES.SHIPMENT.fullString,
    record
  );

  return normalizeDateFields(newRecord, FIELDS_TO_TRANSFORM.DATE_FIELDS);
}
